
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the hash fragment from the URL
        const hashFragment = window.location.hash;
        
        // Log the process
        console.log('Processing auth callback...');
        console.log('URL:', window.location.href);
        
        // Process the callback
        // Supabase will automatically handle the OAuth flow
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth callback error:', error);
          toast({
            title: 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ',
            description: error?.message || 'โปรดลองอีกครั้งในภายหลัง',
            variant: 'destructive',
          });
          navigate('/auth');
          return;
        }
        
        if (data?.session) {
          let raw = searchParams.get('redirect');
          if (!raw) {
            try { raw = sessionStorage.getItem('auth_redirect_path'); } catch (_) { raw = null; }
          }
          const target = raw && raw.startsWith('/') && !raw.startsWith('//') ? raw : '/';
          try { sessionStorage.removeItem('auth_redirect_path'); } catch (_) { /* ignore */ }
          console.log('Authentication successful!');
          toast({
            title: 'เข้าสู่ระบบสำเร็จ',
            description: 'ยินดีต้อนรับกลับมา',
          });
          navigate(target);
        } else {
          console.log('No session found after auth callback');
          navigate('/auth');
        }
      } catch (error) {
        console.error('Error in auth callback:', error);
        toast({
          title: 'เกิดข้อผิดพลาด',
          description: 'ไม่สามารถดำเนินการเข้าสู่ระบบได้ โปรดลองอีกครั้ง',
          variant: 'destructive',
        });
        navigate('/auth');
      }
    };

    handleAuthCallback();
  }, [navigate, toast, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-form-blue mx-auto mb-4" />
        <h2 className="text-2xl font-semibold mb-2">กำลังเข้าสู่ระบบ...</h2>
        <p className="text-gray-500">โปรดรอสักครู่</p>
      </div>
    </div>
  );
};

export default AuthCallback;
